<template>
  <div>
    <app-header title="Label Manager">
      <b-button variant="primary" @click="create()">
        Add Label
      </b-button>
    </app-header>
    <b-container class="mt-5">
      <b-row>
        <b-col>
          <b-form-group>
            <b-form-select v-model="labelType" required>
              <b-form-select-option value="">
                All apps
              </b-form-select-option>
              <b-form-select-option value="dashboard">
                Dashboard
              </b-form-select-option>
              <b-form-select-option value="retail">
                Retail
              </b-form-select-option>
              <b-form-select-option value="customer">
                Customer
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group>
            <b-form-input
              v-model="query"
              type="text"
              class="form-control"
              placeholder="Search"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table-simple striped>
            <b-thead>
              <b-tr>
                <b-td>App</b-td>
                <b-td>Key</b-td>
                <b-td>Default Value</b-td>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr
                v-for="label in filteredLabels"
                :key="label.id"
                @click="editLabel(label)"
              >
                <b-td>{{ label.app }}</b-td>
                <b-td>{{ label.key }}</b-td>
                <b-td>{{ label.value }}</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-col>
      </b-row>
    </b-container>

    <b-modal v-if="activeLabel" title="Edit App Label" ref="labelModal">
      <b-form>
        <b-form-group>
          <b-form-select v-model="activeLabel.app" required>
            <b-form-select-option value="">
              Select App
            </b-form-select-option>
            <b-form-select-option value="dashboard">
              Dashboard
            </b-form-select-option>
            <b-form-select-option value="retail">
              Retail
            </b-form-select-option>
            <b-form-select-option value="customer">
              Customer
            </b-form-select-option>
          </b-form-select>
        </b-form-group>
        <b-form-group>
          <b-form-input
            v-model="activeLabel.key"
            type="text"
            class="form-control"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group>
          <b-form-input
            v-model="activeLabel.value"
            type="text"
            class="form-control"
          ></b-form-input>
        </b-form-group>
      </b-form>

      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            v-if="activeLabel.id"
            type="button"
            variant="danger"
            @click="deleteLabel()"
            class="float-left"
          >
            Delete
          </b-button>
          <b-button
            :disabled="saveDisabled"
            variant="primary"
            @click="saveLabel()"
            class="float-right"
          >
            Save
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import $api from '@/services/api';
import $search from '@/services/search';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    AppHeader,
  },

  data() {
    return {
      labels: null,
      activeLabel: null,
      query: null,
      labelType: '',
    };
  },

  computed: {
    filteredLabels() {
      if (!this.labels) return this.labels;
      const filtered = this.labels.filter((label) => {
        return !this.labelType || label.app === this.labelType;
      });
      return $search(filtered, this.query);
    },
    saveDisabled() {
      return (
        !this.activeLabel || !this.activeLabel.app || !this.activeLabel.key
      );
    },
  },

  created() {
    this.refreshLabels();
  },

  methods: {
    async refreshLabels() {
      this.labels = await $api.get('/v1/internal/applabels');
    },

    async create() {
      this.activeLabel = {
        app: this.labelType,
      };
      await this.$nextTick();
      this.showModal();
    },

    editLabel(label) {
      this.activeLabel = { ...label };
      this.showModal();
    },

    showModal() {
      this.$refs['labelModal'].show();
    },

    killModal() {
      this.$refs['labelModal'].hide();
    },

    async saveLabel() {
      if (this.activeLabel.id) {
        await $api.put(
          `/v1/internal/applabels/${this.activeLabel.id}`,
          this.activeLabel,
        );
      } else {
        await $api.post('/v1/internal/applabels', this.activeLabel);
      }
      await this.refreshLabels();
      this.killModal();
    },

    async deleteLabel() {
      await $api.delete(`/v1/internal/applabels/${this.activeLabel.id}`);
      await this.refreshLabels();
      this.killModal();
    },
  },
};
</script>
